import React, {useMemo} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway'
import Separator from '../../../../components/Simple/Sepperator';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {useTranslation} from 'react-i18next';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import {dateAndTimeToString} from '../../../../utils/utils';
import Sepperator from '../../../../components/Simple/Sepperator';
import SMCButton from '../../../../components/Simple/SMCButton';

const pageSchema = GatewayGetSchema.pages.status;
const pageId = pageSchema.pageId;

function GatewayStatus({
    gatewayObject,
    reloadGatewayStatus
}) {

    const { t } = useTranslation();

    const pageData               = gatewayObject[pageId];
    const created                = pageData[pageSchema.created]
    const lastModified           = pageData[pageSchema.lastModified]
    const lastConnectionDay      = pageData[pageSchema.lastConnectionDay]
    const lastConnectedIpAddress = pageData[pageSchema.lastConnectedIpAddress]
    const reportedFirmware       = pageData[pageSchema.reportedFirmware]
    const connectionStatus       = pageData[pageSchema.connectionStatus]
    const lastUpdateTime         = pageData[pageSchema.lastUpdateTime]
    const currentServer          = pageData[pageSchema.currentServer]
    const lastSyncStatus         = pageData[pageSchema.lastSyncStatus]
    const lastFetchTime          = pageData[pageSchema.lastFetchTime]

    const connectionStatusColor = useMemo(() => {
        switch (connectionStatus) {
            case 'SMP.GATEWAYS.PAGE.STATUS.NOT_CONNECTED':
                return 'red';
            case 'SMP.GATEWAYS.PAGE.STATUS.CONNECTED':
                return 'green';
            case 'SMP.GATEWAYS.PAGE.STATUS.DISABLED':
            case 'SMP.GATEWAYS.PAGE.STATUS.NOT_MANAGED_BY_SMP':
                return 'grey';
            default:
                return undefined;
        }
    }, [connectionStatus]);

    const lastSyncStatusColor = useMemo(() => {
        switch (lastSyncStatus) {
            case 'SMP.GATEWAYS.PAGE.STATUS.ERROR':
                return 'red';
            case 'SMP.GATEWAYS.PAGE.STATUS.SUCCESS':
                return 'green';
            default:
                return undefined;
        }
    }, [lastSyncStatus]);

    return (
        <EditorLayout>
            <SMCTextInput readOnly value={dateAndTimeToString(created, true)} label={t('SMP.GATEWAYS.PAGE.STATUS.CREATED')} />
            <SMCTextInput readOnly value={dateAndTimeToString(lastModified, true)} label={t('SMP.GATEWAYS.PAGE.STATUS.LAST_MODIFIED')} />
            <SMCTextInput readOnly value={dateAndTimeToString(lastConnectionDay, true)} label={t('SMP.GATEWAYS.PAGE.STATUS.LAST_CONNECTION_DAY')} />
            <Separator />
            <SMCTextInput readOnly value={lastConnectedIpAddress} label={t('SMP.GATEWAYS.PAGE.STATUS.LAST_CONNECTED_IP_ADDRESS')} />
            <SMCTextInput readOnly value={reportedFirmware} label={t('SMP.GATEWAYS.PAGE.STATUS.REPORTED_FIRMWARE')} />
            <Separator />
            <SMCTextInput
                readOnly
                value={t(connectionStatus)}
                style={{ color: connectionStatusColor }}
                label={t('SMP.GATEWAYS.PAGE.STATUS.CONNECTION_STATUS')}
            />
            <SMCTextInput readOnly value={dateAndTimeToString(lastUpdateTime, true)} label={t('SMP.GATEWAYS.PAGE.STATUS.LAST_UPDATE_TIME')} />
            <SMCTextInput readOnly value={currentServer} label={t('SMP.GATEWAYS.PAGE.STATUS.CURRENT_SERVER')} />
            <Separator />
            <SMCTextInput
                readOnly
                value={t(lastSyncStatus)}
                style={{ color: lastSyncStatusColor }}
                label={t('SMP.GATEWAYS.PAGE.STATUS.LAST_SYNC_STATUS')}
            />
            <SMCTextInput readOnly value={dateAndTimeToString(lastFetchTime, true)} label={t('SMP.GATEWAYS.PAGE.STATUS.LAST_FETCH_TIME')} />
            <Sepperator />
            <SMCButton onClick={reloadGatewayStatus}>{t('SMP.GATEWAYS.PAGE.STATUS.REFRESH')}</SMCButton>
        </EditorLayout>
    )
}

export default GatewayStatus;